import { Dispatch } from 'redux';
import { api } from "../config/api";
import { GetState } from "../config/store";
import { axiosClient } from '../config/axios';
import { servicesRequest, servicesSuccess, servicesFailure, cleanServicesReducer } from '../reducers/services';

export const getServices = (id: string, userData: any, type_publication: string, typeService: string, selectedVersion: string, image: string, vehicle_price: number, dealershipSelected: string, type: string, brand?: any, pageService?: boolean) => (dispatch: Dispatch) => _getServices(id, userData, type_publication, typeService, selectedVersion, image, vehicle_price, dealershipSelected, type, brand, pageService || false, dispatch);
const _getServices = async (id: string, userData: any, type_publication: string, typeService: string, selectedVersion: string, image: string, vehicle_price: number, dealershipSelected: string, type: string, brand: any, pageService: boolean, dispatch: Dispatch) => {
    try {
        dispatch({ type: servicesRequest });
        const formattedAreaCode = userData.phone.replace(/^\+/, '');

        let body: any;

        if (pageService) {
            body = {
                "company_code": "linze_services",
                "user": {
                    "name": userData.name,
                    "last_name": userData.last_name,
                    "legal_id": userData.legal_id,
                    "email": userData.email,
                    "phone": formattedAreaCode
                },
                "type": type ? type : "",
            };
        } else {
            body = {
                "company_code": "linze_services",
                "user": {
                    "name": userData.name,
                    "last_name": userData.last_name,
                    "legal_id": userData.legal_id,
                    "email": userData.email,
                    "phone": formattedAreaCode
                },
                "product": {
                    "publication": id,
                    "type_publication": brand ? "brand" : type_publication,
                    "vehicle": selectedVersion,
                    "image": image,
                    "vehicle_price": vehicle_price,
                    "business_type": typeService,
                },
                "type": type ? type : "",
            };
        }

        const response = await axiosClient.post(`${api.omuni}/process-info`, body);

        dispatch({ type: servicesSuccess, payload: response?.data });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        dispatch({ type: servicesFailure, payload: errorResponse?.code });
    }
}



export const cleanServices = () => (dispatch: Dispatch) => _cleanServices(dispatch)
const _cleanServices = (dispatch: Dispatch) => dispatch({ type: cleanServicesReducer});